<template>

    <v-content>
        <div v-if="!moduleReport">
            <v-breadcrumbs :items="breadcrumbsItems" large></v-breadcrumbs>
            <v-row>

                <v-col v-show="!usersData.isSpecialUserDepartment" xl="2" md="3" sm="6" cols="12" v-for="title in dashboardItems"
                       v-bind:key="title.link"
                       class="viewCard">
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <router-link :to="title.link">

                                <HoverCard :cardData="title"></HoverCard>

                            </router-link>
                        </template>

                    </v-tooltip>
                </v-col>
                <v-col v-show="usersData.isSpecialUserDepartment" xl="2" md="3" sm="6" cols="12" v-for="title in specialdashboardItems"
                       v-bind:key="title.link"
                       class="viewCard">
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <router-link :to="title.link">

                                <HoverCard :cardData="title"></HoverCard>

                            </router-link>
                        </template>

                    </v-tooltip>
                </v-col>
            </v-row>
        </div>
    </v-content>

</template>






<script>
    import axios from "axios";
    import HoverCard from '@/components/HoverCard'
    import { mapGetters } from "vuex";


    export default {
        name: "CompanySettings",
        data() {
            return {
                departmentData: [],

                snackbar: {
                    formModal: false,
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    drawer: null,
                    drawerRight: null,
                    right: false,
                
                   
                },
                customerData: {
                    updateItem: {}
                },
                branchInformation: [],
            }
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            breadcrumbsItems() {
                return [{
                    text: this.$t('dashboard'),
                    disabled: true,
                    to: "/dashboard",
                    exact: true,
                }]
            },
            dashboardItems() {
                return [
                    //{
                    //    name: this.$t('Real Income Budget'),
                    //    link: "/RealIncomeBudget",
                    //    count: "",
                    //    url: "assets/public/img10.jpg",
                    //    icon: "mdi-account-box"

                    //},
                    //{
                    //    name: this.$t('Real Expenses Budget'),
                    //    link: "/RealExpensesBudget",
                    //    count: "",
                    //    url: "assets/public/img10.jpg",
                    //    icon: "mdi-account-box"

                    //},
                    //{
                    //    name: this.$t('Income Expenses Real Detail'),
                    //    link: "/IncomeExpensesRealReport",
                    //    count: "",
                    //    url: "assets/public/img10.jpg",
                    //    icon: "mdi-account-box"

                    //},
                    //{
                    //    name: this.$t('form_structures'),
                    //    link: '/formStructure',
                    //    count: "",
                    //    url: "assets/public/img12.jpg",
                    //    icon: "mdi-poll"


                    //},
                    //{
                    //    name: this.$t('anusuchara_Report'),
                    //    link: '/anuchcharuReport',
                    //    count: "",
                    //    url: "assets/public/img8.jpg",
                    //    icon: "mdi-receipt"


                    //},
                    //{
                    //    name: this.$t('samikshya_Report'),
                    //    link: '/samikshyaReport',
                    //    count: "",
                    //    url: "assets/public/img9.jpg",
                    //    icon: "mdi-equal-box"


                    //},
                    //{
                    //    name: this.$t('assignForm'),
                    //    link: '/assignForm',
                    //    count: "",
                    //    icon: "mdi-book-open"

                    //},
                    //{
                    //    name: this.$t('upload'),
                    //    link: "/Upload/dashboard",
                    //    count: 0,
                    //    icon: "backup"
                    //},
                    //{
                    //    name: this.$t('report_log'),
                    //    link: "/finalReportLogs",
                    //    count: 0,
                    //    icon: "people"
                    //},
                    //{
                    //    name: this.$t('department_form_assign'),
                    //    link: "/superadminDepartmentAssignForm",
                    //    count: 0,
                    //    icon: "mdi-book-open"
                    //},
                    //{
                    //    name: this.$t('final_anusuchara_Report'),
                    //    link: '/finalAnusucharu',
                    //    count: "",
                    //    url: "assets/public/img8.jpg",
                    //    icon: "mdi-receipt"
                    //},
                    //{
                    //    name: this.$t('second_anusuchara_Report'),
                    //    link: '/secondAnusucharu',
                    //    count: "",
                    //    url: "assets/public/img8.jpg",
                    //    icon: "mdi-receipt"
                    //},
                    //{
                    //    name: this.$t('subjectreportlist'),
                    //    link: '/PoliciesProgramBudgetDashboard',
                    //    count: "",
                    //    url: "assets/public/img8.jpg",
                    //    icon: "mdi-receipt"
                    //},
                    //{
                    //    name: this.$t('yearly_income_source'),
                    //    link: '/IncomeSourceDashboard',
                    //    count: "",
                    //    url: "assets/public/img8.jpg",
                    //    icon: "mdi-receipt"
                    //},
                    //{
                    //    name: this.$t('income_expenses_report'),
                    //    link: '/IncomeExpensesReport',
                    //    count: "",
                    //    url: "assets/public/img8.jpg",
                    //    icon: "mdi-receipt"
                    //},
                    //{
                    //    name: this.$t('companywise_report_log'),
                    //    link: '/CompanyWiseFinalReportLogs',
                    //    count: "",
                    //    url: "assets/public/img8.jpg",
                    //    icon: "mdi-receipt"
                    //},
                    
                ]
            },

            specialdashboardItems() {
                return [
                    {
                        name: this.$t('report_log'),
                        link: "/reportLogs",
                        count: 0,
                        icon: "people"
                    },
                    {
                        name: this.$t('second_anusuchara_Report'),
                        link: '/secondAnusucharu',
                        count: "",
                        url: "assets/public/img8.jpg",
                        icon: "mdi-receipt"


                    },
                    
                ]
            },
        },

        methods: {

            clickEvent(route) {
                this.$router.push({ name: route })
            },
            addFormModal(route) {
                this.snackbar.formModal = true
                this.dynamicComponent.current = route
            },
            dialogueClose() {
                this.customerData.updateItem = {}
                this.snackbar.formModal = false
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
            },
            openDrawer() {
                this.snackbar.drawerRight = !this.snackbar.drawerRight
            },
            async dashboardData() {

                axios.get("Branch/GetBranchInformationByBranchID").then(response => {
                    this.branchInformation = response.data;
                });

                axios.get("Company/CompanyDepartmentCount", {
                    params: {
                        companyID: this.$store.getters.getUserData.companyID

                    }

                }).then(response => {
                    this.departmentData = response.data.details;
                });
                axios.get("Company/CompanyCount", {
                    params: {
                        CompanyID: this.$store.getters.getUserData.companyID
                    }
                }).then(response => {
                    this.snackbar.dashboardItems[1].count = response.data[0].count
                });

            }
        },
        mounted() {
            this.dashboardData()
        },
        components: {
            HoverCard
            /* 'menu-list': CompanyDashboardMenu,*/
            /*// eslint-disable-next-line vue/no-unused-components
            'CompanyForm': () => import(/!* webpackChunkName: "CompanyForm" *!/ '../company/airDestination/CompanyForm'),
            // eslint-disable-next-line vue/no-unused-components
            'SectionsForm': () => import(/!* webpackChunkName: "SectionsForm" *!/ '../company/Sections/SectionsForm'),
            // eslint-disable-next-line vue/no-unused-components
            'PeriodicBudgetForm': () => import(/!* webpackChunkName: "PeriodicBudgetForm" *!/ '../company/PeriodicBudget/PeriodicBudgetForm'),
            // eslint-disable-next-line vue/no-unused-components
            'CustomerForm': () => import(/!* webpackChunkName: "CustomerForm" *!/ '../company/customer/CustomerForm')*/
        }
    }
</script>

<style scoped lang="scss">
    .options {
        border:none;
    }
</style>
